/**
 * @generated SignedSource<<a0c57b5a0d7cca6387c486c2fcd0e20f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchLandingPageQuery$variables = {
  id: string;
};
export type BrainSearchLandingPageQuery$data = {
  readonly node: {
    readonly __typename: "ContentUsage";
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"BrainSearchInput_ContentUsageFragment" | "BrainSearchSidePanelToggle_ContentUsageFragment">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type BrainSearchLandingPageQuery = {
  response: BrainSearchLandingPageQuery$data;
  variables: BrainSearchLandingPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrainSearchLandingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BrainSearchInput_ContentUsageFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BrainSearchSidePanelToggle_ContentUsageFragment"
              }
            ],
            "type": "ContentUsage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrainSearchLandingPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ContentUsage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34ac72e5cfa974c415144b457e255b28",
    "id": null,
    "metadata": {},
    "name": "BrainSearchLandingPageQuery",
    "operationKind": "query",
    "text": "query BrainSearchLandingPageQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on ContentUsage {\n      id\n      ...BrainSearchInput_ContentUsageFragment\n      ...BrainSearchSidePanelToggle_ContentUsageFragment\n    }\n    id\n  }\n}\n\nfragment BrainSearchInput_ContentUsageFragment on ContentUsage {\n  id\n  content {\n    name\n    id\n  }\n}\n\nfragment BrainSearchSidePanelToggle_ContentUsageFragment on ContentUsage {\n  id\n  content {\n    type\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a1f96f42d8cd860971da939ce4eb2ce";

export default node;
